function handleAlbumGridsWithPopup() {
    const albums = document.querySelectorAll('.album.album--grid, .album.album--masonry');

    albums.forEach((album) => {
        let images = [];
        let pictureElements = album.querySelectorAll('picture[data-href]');
        const popupElement = album.querySelector('.popup');
        const popupImgElement = album.querySelector('.popup picture img');
        const closeButton = album.querySelector('.popup__close');
        const nextButton = album.querySelector('.popup__next');
        const previousButton = album.querySelector('.popup__previous');

        if (pictureElements.length && popupElement && popupImgElement && closeButton && nextButton && previousButton) {
            let activeIndex = 0;
            const nextImage = () => {
                activeIndex = (activeIndex+1 >= images.length) ? 0 : activeIndex + 1;
                updateImage(activeIndex);
            };
            const previousImage = () => {
                activeIndex = (activeIndex - 1 < 0) ? images.length -1 : activeIndex - 1;
                updateImage(activeIndex);
            };
            const updateImage = (index) => {
                activeIndex = index;
                popupImgElement.setAttribute('src', images[index]);
            };
            popupImgElement.addEventListener("contextmenu", function (e) {
                e.preventDefault();
            });

            pictureElements.forEach((picture) => {
                let index = images.length;
                picture.setAttribute('data-index', index);
                images.push(picture.getAttribute('data-href'));

                picture.addEventListener('click', () => {
                    updateImage(index);
                    popupElement.removeAttribute('hidden');
                });
                picture.addEventListener("contextmenu", function (e) {
                    e.preventDefault();
                });
            });

            closeButton.addEventListener('click', () => {
                popupElement.setAttribute('hidden', 'hidden');
            });
            nextButton.addEventListener('click', nextImage);
            previousButton.addEventListener('click', previousImage);
            document.addEventListener('swiped-left', previousImage);
            document.addEventListener('swiped-right', nextImage);

            document.onkeydown = (evt) => {
                evt = evt || window.event;

                if (evt.code === 'Escape') {
                    popupElement.setAttribute('hidden', 'hidden');
                }
                if (evt.code === 'ArrowRight') {
                    nextImage();
                }
                if (evt.code === 'ArrowLeft') {
                    previousImage();
                }
            };
        }
    });
}

function initMasonryGrids() {
    const grids = document.querySelectorAll('.album--masonry .album__items');

    if (grids.length === 0) {
        return;
    }

    const Masonry = require('masonry-layout');
    const imagesLoaded = require('imagesloaded');

    grids.forEach((grid) => {
        imagesLoaded(grid, () => {
            const msnry = new Masonry(grid, {
                columnWidth: '.grid-sizer',
                gutter: '.gutter-sizer',
                horizontalOrder: true,
                itemSelector: 'picture',
                percentPosition: true,
            });

            // Check if even bottom edge is enabled via data attribute
            const album = grid.closest('.album--masonry');
            const evenBottomEnabled = album && album.hasAttribute('data-even-bottom');

            if (evenBottomEnabled) {
                // Apply even bottom edge by limiting height to shortest column
                applyEvenBottomEdge(grid, msnry);

                // Re-apply after Masonry completes layout
                msnry.on('layoutComplete', () => {
                    applyEvenBottomEdge(grid, msnry);
                });

                // Re-apply on resize (both window resize and magiq custom document resize event)
                const handleResize = () => {
                    // Reset all styles first so Masonry can calculate properly
                    grid.style.height = '';
                    grid.style.overflow = '';
                    grid.querySelectorAll('picture').forEach(item => {
                        item.style.overflow = '';
                        const img = item.querySelector('img');
                        if (img) {
                            img.style.marginTop = '';
                        }
                    });
                    // Trigger Masonry layout - applyEvenBottomEdge will be called via layoutComplete
                    msnry.layout();
                };

                window.addEventListener('resize', handleResize);
                document.addEventListener('resize', handleResize);
            }
        });
    });
}

function applyEvenBottomEdge(grid, msnry) {
    const items = grid.querySelectorAll('picture');
    if (items.length === 0) return;

    // Reset styles first to get accurate measurements
    grid.style.height = '';
    grid.style.overflow = '';
    items.forEach(item => {
        item.style.overflow = '';
        const img = item.querySelector('img');
        if (img) {
            img.style.marginTop = '';
        }
    });

    const gridRect = grid.getBoundingClientRect();

    // Collect item data and detect columns
    const itemData = [];
    const columnMap = new Map();
    const tolerance = 5;

    items.forEach(item => {
        const rect = item.getBoundingClientRect();
        const leftOffset = Math.round(rect.left - gridRect.left);
        const top = rect.top - gridRect.top;
        const bottom = top + rect.height;

        itemData.push({
            element: item,
            top: top,
            bottom: bottom,
            height: rect.height,
            leftOffset: leftOffset
        });

        // Find existing column within tolerance
        let foundColumn = null;
        for (const [colLeft, colData] of columnMap) {
            if (Math.abs(colLeft - leftOffset) <= tolerance) {
                foundColumn = colLeft;
                break;
            }
        }

        if (foundColumn !== null) {
            const colData = columnMap.get(foundColumn);
            colData.bottom = Math.max(colData.bottom, bottom);
        } else {
            columnMap.set(leftOffset, { bottom: bottom });
        }
    });

    // Find the shortest column height
    const columnBottoms = Array.from(columnMap.values()).map(c => c.bottom);
    if (columnBottoms.length === 0) return;

    const minHeight = Math.min(...columnBottoms);

    // Center images that are partially cut off
    itemData.forEach(data => {
        const cutOff = data.bottom - minHeight;

        if (cutOff > 0) {
            // This image extends below the cut line
            const visibleHeight = data.height - cutOff;

            if (visibleHeight > 0 && visibleHeight < data.height) {
                // Calculate how much to shift the image up to center it
                // We want the center of the original image to align with the center of the visible area
                const shift = cutOff / 2;

                const img = data.element.querySelector('img');
                if (img) {
                    data.element.style.overflow = 'hidden';
                    img.style.marginTop = `-${shift}px`;
                }
            }
        }
    });

    // Apply the height and overflow hidden
    grid.style.height = minHeight + 'px';
    grid.style.overflow = 'hidden';
}

function handleAlbumSlideshow(selectorGlide, selectorThumbs, autoplay = false, animationDuration = 500) {
    if (document.querySelector(selectorGlide)) {
        const glider = new Glide(selectorGlide, {
            animationDuration: animationDuration,
            autoplay: autoplay,
            gap: 0,
            type: autoplay ? 'carousel' : 'slider',
        });
        glider.mount();

        if (selectorThumbs) {
            const thumbs = document.querySelectorAll(selectorThumbs + ' [data-glide-dir]');

            thumbs.forEach(thumb => {
                thumb.addEventListener('click', () => {
                    glider.go(thumb.getAttribute('data-glide-dir'));
                })
            })
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    handleAlbumGridsWithPopup();
    handleAlbumSlideshow('.album.album--slideshow.glide', false, 7000, 2000);
    initMasonryGrids();
});
